import {
  CartMerchandisingType,
  PushProducts,
} from 'types/CartMerchandisingType';
import { useCustomSWR } from 'hooks/useCustomSWR';
import { apiUrls } from 'services/api-urls';
import { fetcher } from 'services/fetcher';

type ReturnType = {
  pushProducts?: PushProducts;
};

export default function useCartMerchandising(): ReturnType {
  const { data: merchandising } = useCustomSWR<CartMerchandisingType>(
    apiUrls.getCheckoutCartMerchandising(),
    fetcher
  );

  return { pushProducts: merchandising?.pushProducts };
}
